<template>
  <v-content></v-content>
</template>

<script>
export default {
  props: {
    notification: { type: Object, default: null }
  },
}
</script>
